// Stripe Checkout and Google sign-in refuse to render inside an iframe (e.g. the Emergent preview panel):
// when framed, navigate the top window instead, with a new tab as fallback.
export const isFramed = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export function openTopLevel(url) {
  if (!isFramed()) {
    window.location.assign(url);
    return;
  }
  try {
    window.top.location.href = url;
    return;
  } catch {
    /* cross-origin top navigation blocked: use a new tab */
  }
  const tab = window.open(url, "_blank", "noopener");
  if (!tab) window.location.assign(url);
}
